import { useState, useEffect } from "react";
import { Waves, Bike, Footprints } from "lucide-react";
import { MOTIVATIONAL_QUOTES } from "@/lib/constants";

const PHASES = [
  { threshold: 20, text: "Đang phân tích hồ sơ tập luyện..." },
  { threshold: 45, text: "Đang xây dựng cấu trúc giai đoạn..." },
  { threshold: 70, text: "Đang tạo bài tập theo từng tuần..." },
  { threshold: 90, text: "Đang hoàn thiện chi tiết plan..." },
  { threshold: 100, text: "Sắp xong rồi..." },
];

export default function LoadingScreen() {
  const [progress, setProgress] = useState(0);
  const [quoteIdx, setQuoteIdx] = useState(0);

  useEffect(() => {
    const startTime = Date.now();
    const interval = setInterval(() => {
      const elapsed = (Date.now() - startTime) / 1000;
      // Smooth ease-out: approaches 98% asymptotically over ~90 seconds
      // Never stops, just continuously slows — no freeze at any point
      const newProgress = 98 * (1 - Math.exp(-elapsed / 25));
      setProgress(newProgress);
    }, 150);
    const quoteInterval = setInterval(() => {
      setQuoteIdx((i) => (i + 1) % MOTIVATIONAL_QUOTES.length);
    }, 3500);
    return () => { clearInterval(interval); clearInterval(quoteInterval); };
  }, []);

  const phaseText = PHASES.find(p => progress < p.threshold)?.text || PHASES[PHASES.length - 1].text;

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 p-6" data-testid="loading-screen">
      <div className="text-center max-w-sm w-full">
        <div className="flex justify-center gap-4 mb-8">
          <Waves className="w-8 h-8 text-sky-400 pulse-glow" style={{ animationDelay: "0s" }} />
          <Bike className="w-8 h-8 text-emerald-400 pulse-glow" style={{ animationDelay: "0.5s" }} />
          <Footprints className="w-8 h-8 text-red-400 pulse-glow" style={{ animationDelay: "1s" }} />
        </div>

        <h2 className="text-white text-2xl font-black uppercase tracking-tight mb-2">
          Đang tạo Training Plan
        </h2>
        <p className="text-slate-400 text-sm mb-6">
          Hệ thống AI đang phân tích và tạo plan riêng cho bạn
        </p>

        {/* Smooth progress bar */}
        <div className="relative h-2 bg-slate-700 rounded-full mb-3 overflow-hidden" data-testid="loading-progress">
          <div
            className="absolute inset-y-0 left-0 bg-gradient-to-r from-orange-500 to-orange-400 rounded-full transition-[width] duration-150 ease-linear"
            style={{ width: `${progress}%` }}
          />
          {/* Shimmer overlay for continuous motion feel */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shimmer" />
        </div>
        <p className="text-orange-400 text-xs font-semibold mb-6 min-h-[16px] transition-opacity duration-300">
          {phaseText}
        </p>

        <p className="text-slate-500 text-sm font-medium italic min-h-[40px] transition-all duration-500">
          "{MOTIVATIONAL_QUOTES[quoteIdx]}"
        </p>
      </div>
    </div>
  );
}
